<template>
	<div class="text-left form-content" :style="paddingStyle" @click="$emit('click',$event)">
		<editor
				ref="textEditor"
				v-if="active && (inBuilder || editMode)"
				:api-key="$store.getters.getTinyMceKey"
				:initial-value="element.text"
				:inline="true"
				:init="mceConfigText"
				@input="handleTextInput"
		></editor>
		<div v-else class="brand-invoice-text" v-html="tokenizedText"></div>
		<div v-if="active && inBuilder" class="row-format mb-n1 mt-1">
			<v-icon size="22" class="material-symbols-outlined" style="cursor: grab">drag_indicator</v-icon>
			<v-icon size="22" class="ml-auto pointer material-symbols-outlined" @click="$emit('delete')">delete</v-icon>
		</div>
	</div>
</template>

<script>
import RendererMixin from "@/modules/forms/v2/schema/RendererMixin";

export default {
	name: "TextBlock",

	props: ['item','active','tokens','tokenMap','inBuilder','editMode'],

	mixins: [RendererMixin],

	components: {
		editor: () => import(/* webpackChunkName: "tinymce" */ '@tinymce/tinymce-vue'),
	},

	data: function () {
		return {
			element: {... this.item},
			mceConfigText: {
				menubar: false,
				inline: true,
				paste_as_text: false,
				paste_data_images: true,
				table_style_by_css: true,
				statusbar: false,
				forced_root_block: 'div',
				plugins: ['paste', 'lists', 'link', 'table', 'autoresize', 'media', 'code'],
				contextmenu: 'paste | link image | table',
				indentation: '12pt',
				skin: this.$vuetify.theme.dark ? 'oxide-dark' : '',
				content_css: this.$vuetify.theme.dark ? 'dark' : '',
				toolbar: [
					'bold italic underline forecolor fontsizeselect | tokenbutton | link unlink code',
					'alignleft aligncenter alignright alignjustify | formatting_group'
				],
				fontsize_formats: "10px 12px 14px 16px 18px 20px 22px 24px 28px 32px 40px 48px",
				toolbar_groups: {
					formatting_group: {
						icon: 'format',
						tooltip: 'Formatting',
						items: 'blockquote bullist numlist indent outdent table | removeformat'
					},
					media_group: {
						icon: 'embed',
						tooltip: 'Media',
						items: ' link unlink media'
					}
				},
				table_toolbar:
						'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',

				setup: (editor) =>  {
					let items = [];
					this.tokens.forEach(t => {
						items.push({
							type: 'menuitem',
							text: t,
							onAction: function () {
								editor.insertContent('{{' + t + '}}');
							}
						});
					})
					editor.ui.registry.addMenuButton('tokenbutton', {
						text: 'Tokens',
						fetch: function (callback) {
							callback(items);
						}
					});
				}
			},
		}
	},

	mounted() {
	},

	beforeDestroy() {
	},

	methods: {
		handleTextInput: function () {
			this.element.text = this.$refs.textEditor.editor.getContent();
			this.$emit('change',this.element);
		},
	},

	computed: {
		// Vue 2 templates can't compile `??`, so the padding style is built here
		paddingStyle: function() {
			return {
				paddingTop: `${this.item.pt ?? 0}px`,
				paddingBottom: this.item.pb == null ? undefined : `${this.item.pb}px`,
				paddingLeft: `${this.item.pl ?? 0}px`,
				paddingRight: `${this.item.pr ?? 0}px`,
			};
		},

		tokenizedText: function(){
			if(!this.element.text){
				return null;
			}

			let text = this.element.text;
			// Saved templates can still contain the original default monthly clause.
			if (this.tokenMap.has('Invoice.LateFeeTerms')) {
				text = text.replaceAll(
					'If invoice is not paid on or before {{Invoice.DateDue}} a {{Invoice.LateFee}}% monthly late fee will be applied to the outstanding balance.',
					'{{Invoice.LateFeeTerms}}'
				);
			}

			this.tokenMap.forEach((value,key) => {
				text = text.replaceAll(`{{${key}}}`,value);
			})

			return text;
		}
	},

	watch: {
		active: function(val){
			if(val){
				setTimeout(() => this.$refs.textEditor.editor.focus(),200);
			}
		}
	}

}
</script>

<style scoped lang="scss">
</style>
